import React from "react";

import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import FASTable from "../../../../../components/Tables/FASTable";
import {
  PayAdjDtl,
  RecAdjDtlFun,
} from "../../../../../Redux/Slice/Fas/ReceivablePayble/ReceivablePaybleSlice";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Detail({
  accountGroup,
  accountName,
  startDate,
  endDate,
}) {
  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const { PayAdjDtldata } = useSelector((state) => state.ReceivablePaybleSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );

  const { theme } = useTheme();
  const isdark = theme;
  const Firm = Cookies.get("Firm");
  const YearId = Cookies.get("FinancialYear");

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return ""; // Invalid date guard

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }
  const getRows = PayAdjDtldata?.Detail?.map((label, index) => ({
    // srNumber: index + 1,
    VouNo: label.VouNo,
    VouDate: formatDateToDDMMYYYY(label.VouDate),
    Type: label.TransactionName,
    ChallanNo: label.ChallanNo,
    AdjTransactionName: label.AdjTransactionName,
    AdjVouno: label.AdjVouno,
    AdjVouDate: label.AdjVouDate,
    BalAmount: label.BalAmount,
    CommulativeBal: label.CommulativeBal,
    OsDays: label.OsDays,
    shortFirmName: label.shortFirmName,
    Amount: label.Amount,
    AdjAmount: label.AdjAmount,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "VouNo", key: "VouNo", align: "center" },
    { label: "VouDate", key: "VouDate", align: "center" },
    { label: "Type", key: "Type", align: "left" },
    { label: "Challan No", key: "ChallanNo", align: "center" },
    { label: "Amount", key: "Amount", align: "right", format: "true" },
    {
      label: "Adj Transaction Name",
      key: "AdjTransactionName",
      align: "left",
    },
    { label: "Adj Vouno", key: "AdjVouno", align: "right" },
    { label: "Adj VouDate", key: "AdjVouDate", align: "right" },
    { label: "Adj Amount", key: "AdjAmount", align: "right", format: "true" },
    {
      label: "Balance Amount",
      key: "BalAmount",
      align: "right",
      format: "true",
    },
    {
      label: "Commulative Balance",
      key: "CommulativeBal",
      align: "right",
      format: "true",
    },
    { label: "Os Days", key: "OsDays", align: "right" },
    { label: "short FirmName", key: "shortFirmName", align: "left" },
  ];

  if (PayAdjDtldata === "no" || PayAdjDtldata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          borderRadius: "12px",
          overflow: "hidden",
          boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
        }}
      >
        <div
          style={{
            backgroundColor:
              isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
            color:
              isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
            padding: "14px",
            margin: 0,
          }}
        >
          <h2
            style={{
              fontSize: "18px",
              margin: 0,
              letterSpacing: "1px",
              fontWeight: "600",
            }}
          >
            DETAIL
          </h2>
        </div>

        <FASTable columns={getColumns} data={getRows} />
      </div>
    </div>
  );
}
